import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { GetCondutorModel, CondutorModel } from '@data/condutor/models';

@Injectable()
export class CondutorRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.CONDUTORES);
  }

  filter(search: string) {
    return this.getRequest<{ data: { results: GetCondutorModel[]; count: number } }>({
      search,
      page: 1,
      offset: 0,
      limit: 10,
    }).pipe(
      map(({ data }) =>
        data.results.map((item) => ({
          label: item.nomeCondutor,
          value: item.codigoCondutor,
        })),
      ),
    );
  }

  getByCPF(cpf: string) {
    return this.customClient.get<{ data: CondutorModel }>(`${this.basePath}/cpf/${cpf}`);
  }
}
